import { render, staticRenderFns } from "./AudioEnter.vue?vue&type=template&id=2f8e7cc6&scoped=true"
import script from "./AudioEnter.vue?vue&type=script&lang=js"
export * from "./AudioEnter.vue?vue&type=script&lang=js"
import style0 from "./AudioEnter.vue?vue&type=style&index=0&id=2f8e7cc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8e7cc6",
  null
  
)

export default component.exports